import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useLinkedPanelState = defineStore("linkedPanelState", () => {
    const WORKDAY_PANELS = {
        START: "workday-start",
        STOP: "workday-stop",
        OFFICE_HOURS: "office-hours",
        TIMEZONE: "timezone",
    };

    const ORGANIZATION_PANELS = {
        ADMIN_ACCESS: "admin-access",
        INVITER_ADMIN: "inviter-admin",
        CAN_SET_EVERYONE_MANDATE: "can-set-everyone-mandate",
        CAN_SET_DOWNLINE_MANDATE: "can-set-downline-mandate",
        CAN_VIEW_EVERYONE_SCREENSHOTS: "can-view-everyone-screenshots",
        CAN_VIEW_DOWNLINE_SCREENSHOTS: "can-view-downline-screenshots",
    };

    const activeWorkdayPanel = ref(null);
    const activeOrganizationPanel = ref(null);

    function setWorkdayStartActive() {
        activeWorkdayPanel.value = WORKDAY_PANELS.START;
    }

    function setWorkdayStopActive() {
        activeWorkdayPanel.value = WORKDAY_PANELS.STOP;
    }

    function setOfficeHoursActive() {
        activeWorkdayPanel.value = WORKDAY_PANELS.OFFICE_HOURS;
    }

    function setTimezoneActive() {
        activeWorkdayPanel.value = WORKDAY_PANELS.TIMEZONE;
    }

    function isWorkdayPanelActive(panel) {
        return activeWorkdayPanel.value === panel;
    }

    function clearActiveWorkdayPanel() {
        activeWorkdayPanel.value = null;
    }

    function setAdminAccessActive() {
        activeOrganizationPanel.value = ORGANIZATION_PANELS.ADMIN_ACCESS;
    }

    function setInviterAdminActive() {
        activeOrganizationPanel.value = ORGANIZATION_PANELS.INVITER_ADMIN;
    }

    function setCanSetEveryoneMandateActive() {
        activeOrganizationPanel.value =
            ORGANIZATION_PANELS.CAN_SET_EVERYONE_MANDATE;
    }

    function setCanSetDownlineMandateActive() {
        activeOrganizationPanel.value =
            ORGANIZATION_PANELS.CAN_SET_DOWNLINE_MANDATE;
    }

    function setCanViewEveryoneScreenshotsActive() {
        activeOrganizationPanel.value =
            ORGANIZATION_PANELS.CAN_VIEW_EVERYONE_SCREENSHOTS;
    }

    function setCanViewDownlineScreenshotsActive() {
        activeOrganizationPanel.value =
            ORGANIZATION_PANELS.CAN_VIEW_DOWNLINE_SCREENSHOTS;
    }

    function isOrganizationPanelActive(panel) {
        return activeOrganizationPanel.value === panel;
    }

    function clearActiveOrganizationPanel() {
        activeOrganizationPanel.value = null;
    }

    const isWorkdayStartActive = computed(() =>
        isWorkdayPanelActive(WORKDAY_PANELS.START),
    );
    const isWorkdayStopActive = computed(() =>
        isWorkdayPanelActive(WORKDAY_PANELS.STOP),
    );
    const isOfficeHoursActive = computed(() =>
        isWorkdayPanelActive(WORKDAY_PANELS.OFFICE_HOURS),
    );
    const isTimezoneActive = computed(() =>
        isWorkdayPanelActive(WORKDAY_PANELS.TIMEZONE),
    );

    const isAdminAccessActive = computed(() =>
        isOrganizationPanelActive(ORGANIZATION_PANELS.ADMIN_ACCESS),
    );
    const isInviterAdminActive = computed(() =>
        isOrganizationPanelActive(ORGANIZATION_PANELS.INVITER_ADMIN),
    );
    const isCanSetEveryoneMandateActive = computed(() =>
        isOrganizationPanelActive(ORGANIZATION_PANELS.CAN_SET_EVERYONE_MANDATE),
    );
    const isCanSetDownlineMandateActive = computed(() =>
        isOrganizationPanelActive(ORGANIZATION_PANELS.CAN_SET_DOWNLINE_MANDATE),
    );
    const isCanViewEveryoneScreenshotsActive = computed(() =>
        isOrganizationPanelActive(
            ORGANIZATION_PANELS.CAN_VIEW_EVERYONE_SCREENSHOTS,
        ),
    );
    const isCanViewDownlineScreenshotsActive = computed(() =>
        isOrganizationPanelActive(
            ORGANIZATION_PANELS.CAN_VIEW_DOWNLINE_SCREENSHOTS,
        ),
    );

    return {
        isWorkdayStartActive,
        isWorkdayStopActive,
        isOfficeHoursActive,
        isTimezoneActive,
        setWorkdayStartActive,
        setWorkdayStopActive,
        setOfficeHoursActive,
        setTimezoneActive,
        clearActiveWorkdayPanel,
        isAdminAccessActive,
        isInviterAdminActive,
        isCanSetEveryoneMandateActive,
        isCanSetDownlineMandateActive,
        isCanViewEveryoneScreenshotsActive,
        isCanViewDownlineScreenshotsActive,
        setAdminAccessActive,
        setInviterAdminActive,
        setCanSetEveryoneMandateActive,
        setCanSetDownlineMandateActive,
        setCanViewEveryoneScreenshotsActive,
        setCanViewDownlineScreenshotsActive,
        clearActiveOrganizationPanel,
    };
});
